let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9qyx8")).then(() => parcelRequire('gGgaG'));